import Vue from 'vue'
import Vuetify from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        // Core brand
        primary: '#00333A', // --teal-300: primary brand, focus buttons, the darkest teal
        secondary: '#3A2D43', // --purple-grey-200: sidebar, secondary elements
        accent: '#00BAB6', // --teal-100: bright teal accent

        // State colors
        error: '#CC4F67', // --cancelled-dark
        success: '#43AF49', // --complete-dark
        warning: '#FC7803', // --attention-orange
        info: '#8F80EE', // --electric-purple-50

        // Extended palette — available as color="X" on Vuetify components
        // and as CSS vars: --v-{name}-base, with utility classes .{name} / .{name}--text
        surface: '#FBFAFC', // --surfaces-bg: card/panel backgrounds
        navHover: '#5A4D63', // --purple-grey-100: sidebar hover states
        marketing: '#B2E22E', // --neon-green-100: marketing/highlight buttons
        anchor: '#039499', // --teal-150: interactive link color
        heading: '#1F4746', // --teal-200: heading text
        dangerBg: '#FFDEDE', // --danger-btn-bg
        dangerText: '#803140', // --danger-btn-text
        chipSuccess: '#AEE8B1', // --complete-light: light success chip bg
        chipWarning: '#FFCB9D', // --incomplete-light
        chipDanger: '#FFAABA' // --cancelled-light
      }
    }
  }
})
